// extracted by mini-css-extract-plugin
export default {"divider":"CommonDivider_divider__I5RnJ","marginTop":"CommonDivider_marginTop__aIgq9","marginTop10":"CommonDivider_marginTop10__bGmAF"};